module.exports = __webpack_public_path__ + "static/media/smartboard.6bfb43bb.svg";